import React, {FC} from "react"
import {Row} from "react-bootstrap"

import {CompanyNewsTileConfig} from "@irati/types"

import Content from "../Content/Content"
import {HomePageView} from "../../types"
import calculateHeightFromContent from "../utils/calculateHeightFromContent"
import {StyledPreview} from "./styled"

interface Props {
  companyNewsTileConfig: CompanyNewsTileConfig
}

const getWidth = (columnWidth: number) => {
  switch (columnWidth) {
    case 3:
      return 292
    case 4:
      return 390
    case 6:
    default:
      return 550
  }
}

const Preview: FC<Props> = ({companyNewsTileConfig}) => {
  const cols = 12 / companyNewsTileConfig.columnWidth
  const arr = []
  for (let index = 0; index < cols; index++) {
    arr.push(index)
  }
  // @ts-ignore
  const height = calculateHeightFromContent(arr)

  return (
    <Row>
      <StyledPreview height={height + 30} width={getWidth(companyNewsTileConfig.columnWidth)}>
        <Content
          companyNewsTile={{
            config: Object.assign({}, companyNewsTileConfig, {columnWidth: 12}),
            xpos: 0,
            ypos: 0
          }}
          pageView={HomePageView.EMPLOYEE_VIEW}
        />
      </StyledPreview>
    </Row>
  )
}

export default Preview
